import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { FractionCalc } from "../components/FractionCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.fr_tool_name()}
        toolPath="/fraction-calculator"
      />
      <SciHeader title={m.fr_h1()} intro={m.fr_intro()} />
      <FractionCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.fr_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.fr_ex1(), m.fr_ex2(), m.fr_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.fr_faq_q1(), a: m.fr_faq_a1() },
          { q: m.fr_faq_q2(), a: m.fr_faq_a2() },
          { q: m.fr_faq_q3(), a: m.fr_faq_a3() },
          { q: m.fr_faq_q4(), a: m.fr_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
